export default __webpack_public_path__ + "static/media/DNo.11-7.db49d7b5.jpg";